import { useContext } from 'react'

import CartContext from '../context/cart.context'

const useCart = () => {
  const cartContextState = useContext(CartContext)
  if (cartContextState.isInitialized) {
    const {
      isActionInProgress,
      removeLineItem,
      updateLineItem,
      isInitialized,
      isInitializing,
      errorMessage,
      setErrorMessage,
      isGoldBarInCart,
      setIsGoldBarInCart,
      isLoggedInUserEligbleForGoldBar,
      addToCart,
      addMultipleToCart,
      newCheckout,
      lineItemDetailsByVariantId,
      isCartPopUpOpen,
      setIsCartPopUpOpen,
      isB2BCartPopupOpen,
      setIsB2BCartPopupOpen,
      cartTotalItemsCount,
      giftCardSpidToSeenState,
      giftCardSpidToDeleteState,
      giftCardSpidToIsPresentInCard,
      updateGiftCardSpidToDelete,
      giftCardSpidToProductMap,
      refreshCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      buyNowCart,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
      removeAllOutOfStockItems,
      refreshFulfillmentDetails,
    } = cartContextState

    return {
      isActionInProgress,
      removeLineItem,
      updateLineItem,
      isInitialized,
      isInitializing,
      errorMessage,
      setErrorMessage,
      isGoldBarInCart,
      setIsGoldBarInCart,
      isLoggedInUserEligbleForGoldBar,
      addToCart,
      addMultipleToCart,
      newCheckout,
      lineItemDetailsByVariantId,
      isCartPopUpOpen,
      setIsCartPopUpOpen,
      isB2BCartPopupOpen,
      setIsB2BCartPopupOpen,
      cartTotalItemsCount,
      giftCardSpidToSeenState,
      giftCardSpidToDeleteState,
      giftCardSpidToIsPresentInCard,
      updateGiftCardSpidToDelete,
      giftCardSpidToProductMap,
      refreshCheckout,
      onSwatchLinkClick,
      swatchData,
      addSwatchesToCart,
      removeSwatches,
      setSwatchData,
      swatchVariantDetailMap,
      buyNowCart,
      isBuyNowInProgress,
      updateGiftingFlag,
      updateGiftingDetails,
      moveToSaveForLater,
      moveBackToCart,
      removeAllOutOfStockItems,
      refreshFulfillmentDetails,
    }
  } else {
    const { isInitialized, isInitializing, setIsCartPopUpOpen, setIsB2BCartPopupOpen } = cartContextState

    return {
      isInitialized,
      isInitializing,
      setIsCartPopUpOpen,
      setIsB2BCartPopupOpen,
    }
  }
}

export default useCart
